import React, { useEffect } from "react";

import Table from "../components/table/Table";

import Modal from "../components/modal/Modal";
import BrokerEntry from "./Broker/BrokerEntry";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllBrokers , reset } from "../redux/features/broker.features";
import StatusCard from "../components/status-card/StatusCard";

const brokerTableHead = [
  "",
  "Id",
  "firstName",
  "lastName",
  "homeAddress", 
  "mobile",
  "email",
  "status",
  
];

const renderHead = (item, index) => <th key={index}>{item}</th>;



const Brokers = () => {
  const dispatch = useDispatch();

  const [showModal, updateShowModal] = React.useState(false);

  const toggleModal = () => updateShowModal((state) => !state);
  useEffect(() => {
    dispatch(fetchAllBrokers());
  }, [dispatch]);

  let brokerState = useSelector((state) => {
    return state.brokerReducer;
  });

  let { brokers, loading , errorMessage , successMessage} = brokerState;

  useEffect(() => {
     
  }, [brokers,loading])
  
  const renderBody = (item, index) => (
    <tr key={index}>
      {/* <td>{item.id}</td> */}
      <td className="text-right flex items-center">
        <div onClick={()=> alert("this features is coming soon")} className="bg-red-500 rounded p-2 bx bx-edit mx-2"></div>
        <div onClick={()=> alert("this features is coming soon")} className="bg-green-500 rounded p-2 bx bx-show mx-2"></div>
        {
         brokers[0] === item &&  (<div onClick={()=> alert("this features is coming soon")} className="bg-purple-500 rounded p-2 bx bx-trash mx-2"></div>)
        }
      </td>
  
      <td>{item.brokerId}</td>
      <td>{item.firstName}</td>
      <td>{item.lastName}</td>
      <td>{item.homeAddress}</td>
      
      <td>{item.mobile}</td>
      <td>{item.email}</td>
      
      <td>{item.status}</td>
     
    </tr>
  );


  return (
    <div>
      {/* <h2 className="page-header ">
        <i className="bx bx-plus page-header__icon"></i>
        
      </h2>
        */}

    <div className="row">
    <div className="col-3">
          <StatusCard
            icon={"bx bx-user"}
            count={brokers.length}
            title={"Brokers"}
          ></StatusCard>
        </div>
    </div>
    <div style={{marginLeft:-10, marginBottom:25,cursor:'pointer', fontSize:'1.2rem'}} className="">

      <div onClick={toggleModal} className="col-3 sidebar__item">
        <div className={`sidebar__item-inner active`}>
          <i className="bx bx-plus"></i>
          <span>Create New Broker</span>
        </div>
      </div>
    </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card__body">
               
                  <Table
                  limit="10"
                  headData={brokerTableHead}
                  renderHead={(item, index) => renderHead(item, index)}
                  bodyData={brokers}
                  renderBody={(item, index) => renderBody(item, index)}
                />
                
             
            </div>
          </div>
        </div>
      </div>

      <Modal
        modal_title={"Create new broker"}
        canShow={showModal}
        updateModalState={toggleModal}
      >
        <BrokerEntry />
      </Modal>
    </div>
  );
};

export default Brokers;
